import { AuthenticateWithRedirectCallback } from '@clerk/clerk-react';
import { Loader2 } from 'lucide-react';
import { useSearchParams } from 'react-router-dom';

export const SSOCallback = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const flow = searchParams.get('flow');
  const activeOrgIdFromUrl = window.location.pathname.split('/')[1];
  const activeOrgId =
    activeOrgIdFromUrl || window.localStorage.getItem('active-org-id');
  const inviteRedirectUrl = `${window.location.origin}/dashboard`;

  return (
    <div className="flex h-screen w-full items-center justify-center">
      <Loader2 className="size-4 animate-spin" />
      <AuthenticateWithRedirectCallback
        signInFallbackRedirectUrl={
          flow === 'invite'
            ? inviteRedirectUrl
            : token
              ? `${window.location.origin}/${activeOrgId}/auth/verify-token?token=${token}`
              : `${window.location.origin}/${activeOrgId}/auth/join-org`
        }
        signUpFallbackRedirectUrl={
          flow === 'invite'
            ? inviteRedirectUrl
            : token
              ? `${window.location.origin}/${activeOrgId}/auth/verify-token?token=${token}`
              : `${window.location.origin}/${activeOrgId}/auth/join-org`
        }
        signInForceRedirectUrl={
          flow === 'invite' ? inviteRedirectUrl : undefined
        }
        signUpForceRedirectUrl={
          flow === 'invite' ? inviteRedirectUrl : undefined
        }
      />
    </div>
  );
};
